import { WobGbdType } from '@/enum/WobGbdType';
import { ConsoleRow } from './ConsoleRow';

export class CoverageIterationUiState {
    
    public typeUiid:string
    public timelineIndex:number  
    public mapStyles:any     
    public refreshSciGraphCache:boolean
    public importedCsvHeaders:Array<string>|null
    public refreshNavGraphCache:boolean
    public infosPanelVisible:boolean    
    public showPath:boolean    
    public showMoreNmea:boolean    
    public showRemainingNavigation:boolean
    public misPlanSelectedGliderIdx:number


    constructor({
                typeUiid="detail", //detail ou global ou fleet
                timelineIndex = -1,                 
                mapStyles = {},                                          
                refreshSciGraphCache = false,
                importedCsvHeaders = [],
                refreshNavGraphCache = false,
                infosPanelVisible = false,
                showPath = true,
                showMoreNmea = false,
                showRemainingNavigation = false,
                misPlanSelectedGliderIdx=0
            } = {}) {  
        this.typeUiid = typeUiid
        this.timelineIndex = timelineIndex
        this.mapStyles = mapStyles                      
        this.refreshSciGraphCache = refreshSciGraphCache
        this.importedCsvHeaders = importedCsvHeaders
        this.refreshNavGraphCache = refreshNavGraphCache
        this.infosPanelVisible = infosPanelVisible                
        this.showPath = showPath
        this.showMoreNmea = showMoreNmea
        this.showRemainingNavigation = showRemainingNavigation
        this.misPlanSelectedGliderIdx = misPlanSelectedGliderIdx        
    }

} 

export const buildCoverageIterationUiStateId = (covId:number,typeuiid:string) => {
    return `coverageiteration_${covId}_${typeuiid}`
}